const contactFormBtn = document.querySelector("[data-contact-form-submit]");
if (contactFormBtn) {
  const successForm = document.querySelector(
    '[data-modal-content="quoteSuccess"]',
  );
  successForm.classList.add("contact-version");
}

const successQuote = getUrlParameter("contact_posted");
console.log(successQuote);
if (successQuote) {
  const successModalTrigger = document.querySelector("[data-quote-success]");
  const successModalContent = document.querySelector(
    "[data-quote-success-content]",
  );
  successModalTrigger.click();

  const title = localStorage.getItem("quoteProduct");
  const imageSrc = localStorage.getItem("quoteImageSrc");
  const imageSrcset = localStorage.getItem("quoteImageSrcset");

  console.log("LOCAL STORAGE", title, imageSrc, imageSrcset);
  if (imageSrc) {
    successModalContent.querySelector("[data-product-image] img").src =
      imageSrc;
    successModalContent.querySelector("[data-product-image] img").srcset =
      imageSrcset;
    successModalContent.querySelector("[data-quote-display-title]").innerHTML =
      title;
  } 
}
